import { toTrainSerie } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/utils";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { DropsBadge, HStack, Text } from "shared/components/Spor";
import colors from "shared/theme/colors";
import { useTheme } from "styled-components";

type TrainSerieDisplayProps = {
  trainIds: string[];
};

export const TrainSerieDisplay: FC<TrainSerieDisplayProps> = ({ trainIds }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const sortedTrainIds = [...trainIds].sort(
    (a, b) => parseInt(a, 10) - parseInt(b, 10),
  );
  return (
    <HStack>
      <DropsBadge
        semantics="info"
        borderWidth="1px"
        gap="6px"
        borderRadius="6px"
        borderColor="#1a3e3b"
        backgroundColor="transparent"
      >
        <DropsBadge
          semantics="info"
          borderWidth="1px"
          borderRadius="6px"
          borderColor={theme.colorInfoOutline}
          backgroundColor={colors.darkBlue}
          marginX="-7px"
        >
          <Text
            variant="2xs"
            fontWeight={700}
            lineHeight="14px"
            whiteSpace="nowrap"
          >
            {toTrainSerie(sortedTrainIds[0])}
          </Text>
        </DropsBadge>
        <Text
          variant="2xs"
          fontWeight={700}
          whiteSpace="nowrap"
          paddingLeft="6px"
        >
          {t("{{count}} tog", { count: sortedTrainIds.length })}
        </Text>
      </DropsBadge>
    </HStack>
  );
};
